export const getTokenLoginPath = (redirectUrl: string, accessToken?: string) => {
  // token-login url works irrespective of the access_token
  const accessTokenQueryParam = accessToken ? `access_token=${accessToken}&` : ''
  return `/token-login?${accessTokenQueryParam}redirect=${encodeURIComponent(redirectUrl)}`
}
